import { IServiceResult } from "../../infrastructure/Interfaces/IServiceResult";
import { SVCMatricula } from "../../infrastructure/services/api/SVCMatricula";
// import IViewParametros from "../../presentation/view-interfaces/IViewParametros";

export const GenerarMatricula = (selListaUpdateProceso: any, idProceso: number, codNegocio: number, idPeriodo: number, idPersona: number) => {
    let list: any = [];
    SVCMatricula.GenerarMatricula(idProceso, codNegocio, idPeriodo, idPersona).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            /* list.push({
            }); */

            selListaUpdateProceso(false, '', data);
        } else {
            selListaUpdateProceso(true, res.errorDetails, list);
        }
    });

};
export const ObtenerMatricula = (
    selListaUpdateProceso: any,
    rut: number, codPrograma: string, 
    codigoNegocio: number, 
    codigoPlanificacion: number, 
    idPeriodo: number
) => {
    let list: any = [];
    SVCMatricula.ObtenerMatricula(rut, codPrograma, codigoNegocio, codigoPlanificacion, idPeriodo).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            /* list.push({
            }); */

            selListaUpdateProceso(false, '', data);
        } else {
            selListaUpdateProceso(true, res.errorDetails, list);
        }
    });

};
export const GenerarComprobanteMatricula = (selListaParametros: any, rut: number, codigoPrograma: string, anio: number, periodo: number, folio: number, codNegocio: number, codigoPlanificacion: number, idPeriodo: number, idPersona: number) => {
    let list: any = [];
    SVCMatricula.GenerarComprobanteMatricula(rut, codigoPrograma, anio, periodo, folio, codNegocio, codigoPlanificacion, idPeriodo, idPersona).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            /* list.push({
            }); */

            selListaParametros(false, '', data);
        } else {
            selListaParametros(true, res.errorDetails, list);
        }
    });

};
export const EnvioCorreo = (selListaParametros: any, rut: number, base64: string, codNegocio: number, declaracion: string, idPeriodo: number, idPersona: number) => {
    let list: any = [];
    SVCMatricula.EnvioCorreo(rut, base64, codNegocio, declaracion, idPeriodo, idPersona).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            /* list.push({
            }); */

            selListaParametros(false, '', data);
        } else {
            selListaParametros(true, res.errorDetails, list);
        }
    });

};
export const EnvioCorreoDeclaracion = (selListaParametros: any, rut: number, base64: string, nombre: string, carrera: string, codPrograma: string, planificacionAcademica: number) => {
    let list: any = [];
    SVCMatricula.EnvioCorreoDeclaracion(rut, base64, nombre, carrera, codPrograma, planificacionAcademica).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            /* list.push({
            }); */

            selListaParametros(false, '', data);
        } else {
            selListaParametros(true, res.errorDetails, list);
        }
    });

};